/** Hide explicitly inactive snapshot profiles; keep legacy rows without active metadata. */
export function isVisibleIssuedRosterNurse(nurse: unknown): boolean {
  return !(
    typeof nurse === "object" &&
    nurse !== null &&
    "active" in nurse &&
    nurse.active === 0
  );
}
